// File: src/hooks/useCreditProjects.js

import { useState, useEffect } from "react";
import axios from "axios";
import { Api_Url } from "../../utils/ApiUrl";
import { toast } from "react-toastify";

export function useCreditProjects() {
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setLoader(true);
        const val = localStorage.getItem("accessToken");

        try {
            const response = await axios.get(
                Api_Url + "/credit/purchasable/projects",
                {
                    headers: {
                        Authorization: "Bearer " + val,
                    },
                }
            );

            setData(response.data.data || []);
            // console.log(response.data.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoader(false);
        }
    };

    const handleToggle = async (id) => {
        const val = localStorage.getItem("accessToken");
        // console.log(id);

        try {
            const response = await axios.patch(
                Api_Url + "/credit/purchasable/projects",
                { id: id },
                {
                    headers: {
                        Authorization: "Bearer " + val,
                        "Content-Type": "application/json",
                    },
                }
            );

            const updatedData = data.map((item) =>
                item._id === id ? { ...item, isActive: !item.isActive } : item
            );
            setData(updatedData);

            toast.success("Project status updated successfully!");
            // console.log("Toggle success:", response.data);
        } catch (error) {
            console.error("Toggle failed:", error?.response || error.message);
            toast.error("Failed to update status.");
        }
    };

    return {
        data,
        loader,
        getData,
        handleToggle,
    };
}
